import { Navigation } from '../components/Navigation'

export function MainLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navigation />

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer. Desktop: a single row — copyright + Questions on the left,
          version + Terms on the right. Mobile: stacked + centered (XD). */}
      <footer className="bg-white text-gray-600 py-5 text-[13px] border-t border-gray-200">
        {/* Desktop single-row layout */}
        <div className="hidden md:flex items-center justify-between px-6 lg:px-10">
          <p>
            &copy; {new Date().getFullYear()} NexSens Technology, Inc.
            <span className="mx-3 text-gray-300">|</span>
            Questions? Call{' '}
            <a href="tel:9374262703" className="text-[#358ECD] hover:underline font-semibold">937.426.2703</a>{' '}
            or email{' '}
            <a href="mailto:info@nexsens.com" className="text-[#358ECD] hover:underline font-semibold">info@nexsens.com</a>
          </p>
          <p>
            <span className="font-semibold text-[#4D4D4D]">WQData LIVE</span> Ver. 4.0.0
            <span className="mx-3 text-gray-300">|</span>
            <a href="/terms" className="text-[#358ECD] hover:underline">Terms and Conditions</a>
          </p>
        </div>

        {/* Mobile stacked/centered layout */}
        <div className="md:hidden text-center space-y-2 px-4">
          <div>
            <p>Questions?</p>
            <p>
              Call{' '}
              <a href="tel:9374262703" className="text-[#358ECD] hover:underline font-semibold">937.426.2703</a>{' '}
              or email{' '}
              <a href="mailto:info@nexsens.com" className="text-[#358ECD] hover:underline font-semibold">info@nexsens.com</a>
            </p>
          </div>
          <p>
            <span className="font-semibold text-[#4D4D4D]">WQData LIVE</span> Ver. 4.0.0
            <span className="mx-3 text-gray-300">|</span>
            <a href="/terms" className="text-[#358ECD] hover:underline">Terms and Conditions</a>
          </p>
          <p>&copy; {new Date().getFullYear()} NexSens Technology, Inc.</p>
        </div>
      </footer>
    </div>
  )
}
